import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, EventEmitter, Input, OnInit, Output, NgModule, AfterViewInit, Inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalizationService } from '@services/localization.service';
import { getLiveScorePage } from '@environments/environment';
import { UiHelper } from '@helpers/ui.helper';

@Component({
  selector: 'livescore',
  templateUrl: '../sharedTemplates/livescore.component.html',
})
export class LiveScoreComponent implements OnInit {
  iframe_src;

  constructor(private domSanitizer: DomSanitizer, public _LZ: LocalizationService, public _UiHelper: UiHelper) {}

  ngOnInit() {
    let url = '';

    url = getLiveScorePage(this._LZ.LANGCODE);

    this.iframe_src = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
